import { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Papa from "papaparse";
import moment from "moment";
import axiosInstance from "./axiosInstance"

const RunnerCSVRace = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [file, setFile] = useState(null);
    const [formErrors, setFormErrors] = useState({});

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    const handleFileChange = (e) => {
        console.log("change")
        if (e.target.files) {
            Papa.parse(e.target.files[0], {
                header: true,
                skipEmptyLines: true,
                dynamicTyping: false,
                encoding: "UTF-8",
                transform: function (value, column) {
                    if (column === 'birth') {
                        value = moment(value, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');
                    }
                    return value;
                },
                complete: function (results) {
                    setFile(results.data)
                    console.log(results.data)
                },
                error: function (error) {
                    console.log('error');
                },

            })
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const rtg = file.map((item) => ({
            "runner": {
                "name": item.name,
                "firstname": item.firstname,
                "birth": item.birth,
                "gender": item.gender
            },
            "bib": item.bib,
            "tag": item.tag,
            "race": props.raceId,
            "category": item.category,
            "subrace": item.subrace
        }));
        axiosInstance.patch('/racepersontags/import_csv/', rtg)
            .then(response => {

            })
            .catch(error => {
                setFormErrors(error.response.data)
            })
    }

    return (<>
        <Button onClick={openModal}>Upload</Button>
        <Modal show={showModal} onHide={closeModal} size="xl">
            <Modal.Header>

            </Modal.Header>
            <Modal.Body>
                {/* <Table>
                    <th>

                        <td>firstname</td>
                        <td>name</td>
                        <td>birthDate</td>
                        <td>Sex</td>
                        <td>Bib</td>
                        <td>Category</td>
                    </th>
                </Table> */}
                <Form.Control type="file"
                    onChange={handleFileChange}
                    accept=".csv" />

                <Table>
                    <thead>
                        <tr>
                            <th>firstname</th>
                            <th>name</th>
                            <th>birth</th>
                            <th>gender</th>
                            <th>bib</th>
                            <th>tag</th>
                            <th>subrace</th>
                        </tr>
                    </thead>
                    <tbody>
                        {file && file.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <Form.Control
                                        defaultValue={item.firstname}
                                        name="firstname"
                                        isInvalid={formErrors && formErrors[index]?.firstname}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.firstname}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        defaultValue={item.name}
                                        name="name"
                                        isInvalid={formErrors && formErrors[index]?.lastName}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.lastName}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        defaultValue={item.birth}
                                        type="date"
                                        name="birth"
                                        isInvalid={formErrors && formErrors[index]?.birthDate}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.birthDate}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        defaultValue={item.gender}
                                        name="gender"
                                        isInvalid={formErrors && formErrors[index]?.gender}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.gender}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        defaultValue={item.bib}
                                        type="text"
                                        name="bib"
                                        isInvalid={formErrors && formErrors[index]?.bib}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.bib}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        defaultValue={item.tag}
                                        type="text"
                                        name="tag"
                                        isInvalid={formErrors && formErrors[index]?.tag}
                                        style={{ minWidth: '250px' }}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.tag}</Form.Control.Feedback>
                                </td>
                                <td>
                                    <Form.Control
                                        defaultValue={item.subrace}
                                        type="text"
                                        name="subrace"
                                        isInvalid={formErrors && formErrors[index]?.subrace}
                                        style={{ minWidth: '250px' }}
                                    // onChange={(e) => handleFileChangeInput(e, index)}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors && formErrors[index]?.subrace}</Form.Control.Feedback>
                                </td>
                            </tr>
                        ))}
                        <Button onClick={handleSubmit}>Upload</Button>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    </>
    )
}

export default RunnerCSVRace;